import { BaseNumberQuestionNode } from './BaseNumberQuestionNode'

export class PercentageQuestionNode extends BaseNumberQuestionNode {
  public stringifyValue(): string {
    return this.isInputEmpty() ? '' : `${this.getStringValue()}%`
  }
}
